import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
import profile from "./assets/profile2.jpg";
import java from "./assets/techstack/java.png";
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import spring from "./assets/techstack/spring.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import eclipse from "./assets/techstack/eclipse.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
import wise from "./assets/projects/wisetime.png";
import papelariaproject from "./assets/projects/papelaria.png";
import taxbrain from "./assets/projects/taxbrain.png";
import reconhecimentofacial from "./assets/projects/secretaria.png";
import exo from "./assets/projects/exo.png";

export const logos = {
  logogradient: logogradient,
  logo: logo,
};

export const personalDetails = {
  name: "Eduardo Neto",
  tagline: "Desenvolvedor Back-End",
  img: profile,
  about: `Olá, prazer eu sou Eduardo Neto, sou Desenvolvedor Java e ReactJS, trabalho com padrão MVC, API’s Rest, SpringBoot e Microservices.`,
};

export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/eduardo-gavronski-neto-7013731aa/",
  github: "https://github.com/eduardogneto",
  twitter: "https://twitter.com/uudebr",
  instagram: "https://www.instagram.com/uude1",
};

export const workDetails = [
  {
    Position: "Software Engineer II",
    Company: `SoftDesign`,
    Location: "Porto Alegre - RS",
    Type: "Remoto",
    Duration: "Jun 2026 - Atual",
  },
  {
    Position: "Mid-Level Java Developer",
    Company: `CI&T`,
    Location: "Campinas - SP",
    Type: "Remoto",
    Duration: "Nov 2024 - Mai 2026",
  },
  {
    Position: "Analista de Desenvolvimento de Sistemas",
    Company: `TOTVS`,
    Location: "Joinville - SC",
    Type: "Híbrido",
    Duration: "Set 2022 - Out 2024",
  },
  {
    Position: "Software Engineer",
    Company: `Exo`,
    Location: "Joinville - SC",
    Type: "Remoto",
    Duration: "Jul 2020 - Set 2022",
  },
];

export const eduDetails = [
  {
    Position: "Bacharelado em Engenharia de Software",
    Company: `Universidade Católica de Santa Catarina`,
    Location: "Joinville - SC",
    Type: "Presencial",
    Duration: "Mar 2020 - Dez 2024",
  },
  {
    Position: "Pós-graduação MultiCloud, Devops & IA",
    Company: `The Cloud Bootcamp`,
    Location: "San Francisco - CA",
    Type: "Remoto",
    Duration: "Out 2025 - Out 2026",
  },
];

export const techStackDetails = {
  java : java,
  html: html,
  css: css,
  js: js,
  react: react,
  spring: spring,
  sass: sass,
  vscode: vscode,
  postman: postman,
  eclipse: eclipse,
  git: git,
  github: github,
  figma: figma,
};

export const projectDetails = [
  {
    title: "WiseTime",
    image: wise,
    description: `Projeto desenvolvido para gerenciar o tempo de trabalho dos colaboradores, com controle total de horas adicionadas e atestadas, auditoria e relatórios`,
    techstack: "Java 17, ReactJs, SpringBoot 3",
  },
  {
    title: "Exo Roleplay",
    image: exo,
    description: `Projeto desenvolvido para comercialização de microtransações para o servidor Exo Roleplay, integrado a API de pagamento Asaas e API de login do Discord`,
    techstack: "NodeJs, ReactJs, PostgreSQL, Nginx",
  },
  {
    title: "Taxbrain",
    image: taxbrain,
    description: `Projeto desenvolvido para gerenciar a contabilidade de empresas, com calculo de impostos, relatórios e gerenciamento de clientes.`,
    techstack: "NodeJs, ReactJs, MongoDB",
  },
  {
    title: "Papelaria Flamingo's",
    image: papelariaproject,
    description: `Projeto desenvolvido para gerenciar toda a papelaria, com controle de estoque, controle de vendas, relatórios das ações e gerenciamento de clientes.`,
    techstack: "HTML/CSS, JavaScript",
  },
  {
    title: "Secretária Inteligente com reconhecimento facial",
    image: reconhecimentofacial,
    description: `Esta aplicação foi desenvolvida para facilitar o atendimento de consultorios, não sendo mais necessário a presença de uma secretária`,
    techstack: "Java, ReactJs, Python",
  }
];

export const contactDetails = {
  email: "eduardogavronskineto@gmail.com",
  insta: "uude1",
};
